import { PublicKey } from '@solana/web3.js';

// Known locker programs and burn address on Solana
export const LOCKER_PROGRAMS = [
  'strmRqUCoQUgGUan5YhzUZa6KqdzwX5L6FpUxfmKg5m', // Streamflow
  '2eBBAavmT954pCFZ5fBuH2QuaW5EJpR5yPBQNQF4X7ap', // Smithii
  '1nc1nerator11111111111111111111111111111111', // Burn address / incinerator
];

/**
 * Determine whether a given LP mint has its liquidity effectively locked.
 * Null mint authority is treated as renounced, and known locker program IDs
 * as held by a locker.
 *
 * @param {string} lpMintAddress
 * @param {import('@solana/web3.js').Connection} connection
 * @returns {Promise<{ locked: boolean, reason: string }>}
 */
export async function isLiquidityLocked(lpMintAddress, connection) {
  if (!lpMintAddress || !connection) {
    return { locked: false, reason: 'Missing LP mint or connection' };
  }

  try {
    const mintPubkey = new PublicKey(lpMintAddress);
    const mintInfo = await connection.getParsedAccountInfo(mintPubkey);
    const parsed = mintInfo.value?.data?.parsed;
    const authorityRaw = parsed?.info?.mintAuthority;

    const authority =
      typeof authorityRaw === 'string'
        ? authorityRaw
        : authorityRaw?.toString?.() ?? null;

    // Null = renounced, known locker = locked
    if (!authority) return { locked: true, reason: 'Authority renounced' };
    if (LOCKER_PROGRAMS.includes(authority)) {
      return { locked: true, reason: 'Held by locker' };
    }

    return { locked: false, reason: 'Not locked' };
  } catch (err) {
    // On any error, fall back to unlocked so we do not overstate safety
    console.warn('isLiquidityLocked error:', err);
    return { locked: false, reason: 'Not locked' };
  }
}

